import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import axios from "axios";
import React, { useState, useEffect } from "react";

const clientId = "379096657966-d3269c1fhvg1nun1qi3095lcfvqadn6b.apps.googleusercontent.com";

function Login(delay) {
    axios.defaults.withCredentials = true;

    const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, delay);
    return () => clearTimeout(timer);
  }, [delay]);


    const onSuccess = (res) => {

        // Send token to your backend using Axios POST request
        axios.post(`${process.env.REACT_APP_Apiurl}login`, { token: res.credential })
          .then((response) => {
            console.log("Response from server:", response.data);
            window.location.href = process.env.REACT_APP_App_Url + "overview";
          })
          .catch((error) => {
            console.error("Error sending token to server:", error);
            // Handle error appropriately
          });
    }

    
    return (
        <div
      className={`option py-1 px-4 opacity-0 transition-opacity duration-1000 ${
        show ? "opacity-100" : ""
      }`}
    >
        <GoogleOAuthProvider clientId={clientId}  >

                <GoogleLogin
                onSuccess={onSuccess}
                onError={() => {
                    console.log('Login Failed');
                }}
                theme = "filled_black"
            />

            
        </GoogleOAuthProvider>
        </div>
    )
}

export default Login;
